import { CompassCardUI } from '@scale/compass-ui/types';
import {
  TagActionsCardShared,
  type TagActionsContextSchemaType,
  type TagActionsContext,
  TAG_ACTIONS,
  TAG_ACTION_MODE,
  TAG_OPERATION_TYPE,
} from '@scale/genai-compass-shared/cards/tag_actions';
import { faTags } from '@fortawesome/pro-solid-svg-icons';
import TagActionsCardComponent from 'react-scale/corp/views/DataCompassCardsV2/action/TagActions/TagActionsCardComponent';

const defaultContext: TagActionsContext = {
  cardType: TAG_ACTIONS,
  mode: TAG_ACTION_MODE.STANDARD,
  userIdColumn: '',
  operationType: TAG_OPERATION_TYPE.ADD_TAGS,
  tagIds: [],
};

export const TagActionsCardInfo: CompassCardUI<TagActionsContextSchemaType> = {
  ...TagActionsCardShared,
  title: 'Tag Actions',
  icon: 'tags',
  toolTip: 'Add or remove tags from users in standard or dynamic mode.',
  defaultContext,
  ownerTeam: 'Pay / Growth',
  showOutput: true,
  button: {
    icon: faTags,
  },
  legacyComponent: TagActionsCardComponent,
  isLegacy: true,
};
